import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmationDialogComponent } from './confirmation-dialog.component';
import { MaterialModule } from '../../material.module';
import { TranslateModule } from '@ngx-translate/core';
import { ActionButtonModule } from '../action-button';

@NgModule({
  declarations: [ConfirmationDialogComponent],
  imports: [CommonModule, ActionButtonModule, MaterialModule, TranslateModule],
})
export class ConfirmationDialogModule {}
